const getAge = () =>
  new Date().getFullYear() -
  new Date(1999, 2, 26).getFullYear() -
  (new Date().getMonth() < 2 ||
  (new Date().getMonth() === 2 && new Date().getDate() < 26)
    ? 1
    : 0);

export default getAge;
